import { ADSENSE_PUBLISHER_ID } from '@/config/adExperiments.js'
import { isAdsMockEnabled } from '@/config/adFlags.js'
import { emitAdEvent } from './adTelemetry.js'
import { resolveAutoAds } from './adExperiments.js'

export const AUTO_ADS_SCRIPT_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_PUBLISHER_ID}`
export function autoAdsDocumentLoaded() { return Boolean(document.querySelector('script[data-visualg-auto-ads]')) }

export function loadAutoAds(policy, pathname) {
  const decision = resolveAutoAds(policy, pathname)
  if (!decision || isAdsMockEnabled() || autoAdsDocumentLoaded()) return
  const queue = window.adsbygoogle = window.adsbygoogle || []
  queue.requestNonPersonalizedAds = 1
  const script = document.createElement('script')
  script.async = true
  script.crossOrigin = 'anonymous'
  script.src = AUTO_ADS_SCRIPT_SRC
  script.dataset.visualgAutoAds = decision.experiment
  // Observations concern library delivery; only Google reports billable revenue.
  const metadata = { placement: 'autoAds', position: decision.experiment === 'auto_anchors' ? 'auto.anchor' : 'auto.in_page', pageFamily: 'seo_download', experiment: decision.experiment, variant: decision.variant, eligible: true }
  script.addEventListener('load', () => emitAdEvent('library_ready', metadata), { once: true })
  script.addEventListener('error', () => emitAdEvent('library_error', { ...metadata, reason: 'auto_ads_script_error' }), { once: true })
  if (window.happyDOM?.settings?.disableJavaScriptFileLoading) script.type = 'text/plain'
  document.head.appendChild(script)
}
